import { TIMESHEET_APPLICANT_STATUSES } from "./constants";

const readIsRemovedWorkingLog = (log = {}) =>
  log.is_removed === true ||
  log.is_removed === "true" ||
  log.is_removed === 1 ||
  log.is_removed === "1";

export const mapEventRequestStatusToUiStatus = (
  eventRequestStatus,
  { isRemoved = false } = {},
) => {
  if (
    eventRequestStatus === TIMESHEET_APPLICANT_STATUSES.cancelled ||
    eventRequestStatus === "auto_cancelled"
  ) {
    return TIMESHEET_APPLICANT_STATUSES.cancelled;
  }

  if (isRemoved || eventRequestStatus === TIMESHEET_APPLICANT_STATUSES.removed) {
    return TIMESHEET_APPLICANT_STATUSES.removed;
  }

  if (!eventRequestStatus) {
    return null;
  }

  if (eventRequestStatus === TIMESHEET_APPLICANT_STATUSES.approved) {
    return TIMESHEET_APPLICANT_STATUSES.approved;
  }

  return eventRequestStatus;
};

export const mapWorkingLogToApplicantRow = (log = {}) => {
  const isRemoved = readIsRemovedWorkingLog(log);

  return {
    ...log,
    id: String(log.id),
    working_log_id: log.id,
    working_days: log.number_of_days ?? 0,
    working_hours: log.working_hours,
    training_days: log.training_number_of_days ?? 0,
    status: mapEventRequestStatusToUiStatus(log.event_request_status, {
      isRemoved,
    }),
    event_request_status: log.event_request_status,
    is_removed: isRemoved,
  };
};

export const mapWorkingSlotRow = (slot = {}) => ({
  ...slot,
  shift: slot.event_role_shift ?? slot.shift,
});

export const mapTrainingWorkingSlotRow = (slot = {}) => ({
  ...slot,
  shift: slot.event_role_shift ?? slot.shift,
});
